export default {
  name: 'TripConfig',

  computed: {
    tripConfigCreateConfig () {
      return {
        title: this.$t('fleet/vehicle.trip_config'),
        key: 'tripConfig',
        validationErrors: this.validationErrors,
        visible: this.tripConfigVisible,
        tabContent: [
          {
            title: this.$t('fleet/vehicle.trip_config'),
            component: this.columnsContentComponent,
            rows: [
              {
                columnsCount: 3,
                fields: [
                  {
                    key: 'trip_config_id',
                    label: this.$t('fleet/vehicle.trip_config'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'trip-configs'
                    },
                    visible: true,
                    editable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
